import Path from "components/path/Path";
import Bar from "components/Bar";
import SlideUpNow from "components/animation/SlideUpNow";

export default function Banner(props){
  const url = `url(${props.bg})`;
  return (
    <div className="h-full">
      <div className="overflow-hidden">
      <div 
        className={`${props.className} -z-10 scaleDown flex flex-col justify-center items-center pb-40 w-full h-screen bg-cover `} 
        style={{backgroundImage:url}}>
        <div className="mb-2">
          <p className={`fadeIn text-2xl tracking-widest text-white font-extralight`}>{props.menuName}</p>
        </div>
        <SlideUpNow delay={300} top={0}>
          <p className={`lg:font-thin text-center tracking-wide text-white text-3xl lg:text-8xl`}>{props.title}</p>
        </SlideUpNow>
        <div className="my-4">
          <Bar className={`fadeIn`} width="47px"/>
        </div>
        <SlideUpNow dealy={800} top={0}>
          <p className={`text-center text-white px-mobile`} 
          dangerouslySetInnerHTML={{__html:props.comment}}></p>
        </SlideUpNow>
      </div>
      </div>
      <div className="relative z-20 flex flex-col w-auto p-6 -mt-12 bg-white lg:-mt-20 lg:p-10 hold mx-mobile lg:mx-pc">
        <Path className="mb-6" path={props.path}/>
      </div>
    </div>
  );
}

